import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { UserCalendarDto } from '../schema/types';
import { UserCalendarUrl } from '../../UserDashboardUrl';

const getUserCalendar = () =>
  apiClient
    .get<UserCalendarDto[]>(expand(UserCalendarUrl.CALENDAR))
    .then((response) => response.data);

export const useGetUserCalendarQuery = createApiQueryHook(
  ['user-calendar'],
  getUserCalendar,
);
